import { readUnhandledEnumCase } from 'rpc-client-utils';
import env from 'enviro';
function propertyValueBackport(property) {
  return Object.assign({}, property, {
    dataSensitivity: property.dataSensitivity ? readUnhandledEnumCase(property.dataSensitivity) : undefined,
    source: property.source ? readUnhandledEnumCase(property.source) : undefined,
    value: property.value
  });
}
function propertyWithVersionsBackport(property) {
  if (Array.isArray(property.versions)) {
    var _property$versions$;
    return Object.assign({}, propertyValueBackport((_property$versions$ = property.versions[0]) !== null && _property$versions$ !== void 0 ? _property$versions$ : {}), {
      versions: property.versions
    });
  }
  if (!env.isProd() || !env.deployed()) {
    throw new Error('framework-listing-lib recieved a property from CHIRP (or MSW) without a versions field');
  }

  // Fallback, most likely it's a virtual property using the old format where
  // the current fields are at the top level
  return Object.assign({}, property);
}

/**
 * Historically the backend spread the latest property version's fields in the top level of the property object
 * But this functionality was lost in the migration to chirp, as it was implemented with @Lazy-decorated fields
 * which aren't supported in chirp
 *
 * https://hubspot.slack.com/archives/C01LHLYF7K4/p1757083807749449?thread_ts=1756403380.565379&cid=C01LHLYF7K4
 * https://product.hubteam.com/docs/chirp/pages/guides/derived-fields.html
 */
export function chirpCrmObjectPropertyVersionsBackport(crmObject) {
  return Object.assign({}, crmObject, {
    properties: Object.fromEntries(Object.entries(crmObject.properties).map(([key, property]) => [key, propertyWithVersionsBackport(property)]))
  });
}